/* PDP gallery geometry.

   WHAT THIS FILE USED TO DO, AND WHY IT WAS WRONG.
   An earlier version forced the media column's height to match the buy-box column so both
   ended on the same line. Measured on the live site 11 Aug, that produced a main frame of
   616 x 1117 — an aspect of 0.551, far taller and narrower than any asset we have:
       product photos  1856x2304  = 0.806  (4:5)
       text panels     1200x1800  = 0.667  (2:3)
   With object-fit:cover the frame ate the top and bottom of every slide, which is why the
   word "HIGHLIGHTS" was sliced in half and the hero looked small and cropped. The columns
   were never misaligned — all four measured top:213 — the frame was simply the wrong shape.

   THE RULE NOW: the frame keeps a 4:5 aspect, which matches the photographs exactly, and
   slides are object-fit:contain so a 2:3 panel letterboxes on a matching background rather
   than losing its text. Never re-introduce a height derived from the text column; making
   the two columns end level is not worth cropping the product.

   Thumbnails are sized to the frame so the rail still ends with the image. */
(function(){
  var FRAME_BG = '#f4f3f1';

  function css(){
    if (document.getElementById('luma-gal-css')) return;
    var s = document.createElement('style');
    s.id = 'luma-gal-css';
    s.textContent = ''
      + '.lp .wrap .main{aspect-ratio:4/5!important;height:auto!important;'
      +   'background:' + FRAME_BG + '!important;}'
      /* contain, not cover: panels are 2:3 and must not lose their type */
      + '.lp .wrap .main img,.lp .wrap .main .mimg{object-fit:contain!important;'
      +   'background:' + FRAME_BG + '!important;height:100%!important;}'
      + '.lp .wrap .thumbs .t img{object-fit:contain!important;background:' + FRAME_BG + '!important;}';
    document.head.appendChild(s);
  }

  /* keep the thumbnail rail the same height as the frame */
  function sizeThumbs(){
    var main = document.querySelector('.lp .wrap .main');
    var rail = document.querySelector('.lp .wrap .thumbs');
    if (!main || !rail) return;
    var tiles = rail.querySelectorAll('.t');
    if (!tiles.length) return;
    var target = main.getBoundingClientRect().height;
    if (!target) return;
    var gap = parseFloat(getComputedStyle(rail).gap) || 12;
    var each = Math.floor((target - (gap * (tiles.length - 1))) / tiles.length);
    if (each < 40) return;
    tiles.forEach(function(t){ t.style.setProperty('height', each + 'px', 'important'); });
    rail.style.setProperty('max-height', target + 'px', 'important');
  }

  function run(){ css(); sizeThumbs(); }

  run();
  document.addEventListener('DOMContentLoaded', run);
  window.addEventListener('load', run);
  window.addEventListener('resize', sizeThumbs);
  [200, 700, 1600, 3000].forEach(function(d){ setTimeout(run, d); });

  if (window.ResizeObserver) {
    var m = document.querySelector('.lp .wrap .main');
    if (m) new ResizeObserver(sizeThumbs).observe(m);
  }
})();